// extracted by mini-css-extract-plugin
module.exports = {"tab":"_tab_tab__yHimN","tabIsActive":"_tab_tabIsActive__lSB3k"};